export { default as useProductsIndexContentSelectedProducts } from './useProductsIndexContentSelectedProducts';
